import { http } from './http'
import { User } from '../types'

export const updateUser = async (payload: Partial<User>, id: string): Promise<{ user: User }> => {
  const { data } = await http.patch<Partial<User>>(`/v2/users/${id}`, payload, {
    withCredentials: true
  })
  return data as unknown as { user: User }
}

export const getMe = async (): Promise<User> => {
  const { data } = await http.get<User>(`/v2/users/me`)
  return data
}

export const logout = async (): Promise<void> => {
  await http.post<User>(`/v2/users/logout`)
}

export const getUser = async (id: string): Promise<User> => {
  const { data } = await http.get<User>(`/v2/users/${id}`)
  return data
}

export const getAllUsers = async (): Promise<User[]> => {
  const { data } = await http.get<User[]>(`/v2/users`, {
    withCredentials: true
  })
  return data
}
